export default __webpack_public_path__ + "static/media/person-dog-walking.c8fc28a7.png";